export default "__VITE_ASSET__DPtCzGXz__"